// SCR-TUT-LETTER — шаг T01 (ux/11 §1.3, ГД 12 §3): DOM-экран, «Взять ключ» активна с первого кадра;
// в 10.0 с от первого кадра ключ берётся сам. Строка согласия мелко под кнопкой (У-К-38): «Взять ключ»
// отправляет POST /me/consents фоном, шаг не блокирует.
import { useEffect, useRef, useState } from 'preact/hooks';

import { useApp } from '../app/app.js';
import { storage } from '../state/storage.js';
import { markChatRulesAccepted } from '../state/legal.js';
import { completeStep, startTutorial, TEXT } from './flow.js';
import { I } from '../assets/icons.js';
import { t as tr } from '../i18n/t.js';
import { Typed } from '../ui/text-fx.js';

export const T01_AUTO_MS = 10_000;

export function TutLetter() {
  const app = useApp();
  const [auto, setAuto] = useState(false);
  const done = useRef(false);
  const take = async (byTimer: boolean) => {
    if (done.current) return;
    done.current = true;
    if (byTimer) setAuto(true);
    app.haptic('medium');
    const docs = storage.getJson<{ docId: 'terms' | 'privacy' | 'chat_rules'; version: string }[]>('consentsRequired') ?? [];
    for (const d of docs) void app.call('acceptConsent', { body: { docId: d.docId, version: d.version } }).then(() => { storage.remove('consentsRequired'); if (d.docId === 'chat_rules') markChatRulesAccepted(d.version); }).catch(() => {});
    const r = await completeStep(app, 'T01', byTimer ? 'auto' : 'take_key');
    startTutorial(app, r.step);
  };
  useEffect(() => {
    const t = setTimeout(() => { void take(true); }, T01_AUTO_MS);
    return () => clearTimeout(t);
  }, []);
  return (
    <div class="tut-letter" data-testid="SCR-TUT-LETTER">
      <article class="letter" aria-label={tr('TUT-T01-01')}>
        <div>
          <div style={{ fontSize: 15, opacity: 0.7, fontFamily: 'system-ui' }}>{tr('TUT-T01-01')}</div>
          <p style={{ margin: '10px 0 0' }}><Typed text={tr('TUT-T01-02')} cps={45} /></p>
        </div>
        <div class="key"><I n="key" size={48} /></div>
      </article>
      <button class="btn accent block" style={{ maxWidth: 420, minHeight: 56, flex: '0 0 auto' }} data-tut="take-key" data-testid="take-key" onClick={() => { void take(false); }}>
        {auto ? TEXT.T01auto : tr('TUT-T01-03')}
      </button>
      <div class="consent-line">{tr('CL-TUTORIAL-LETTER-01')}{" "}<a href="#" onClick={(e) => { e.preventDefault(); app.wa?.openLink?.('https://example.invalid/legal/terms'); }}>{tr('CL-TUTORIAL-LETTER-02')}</a></div>
    </div>
  );
}
